import reducer from './reducers/index'
import { settings } from '../../../settings/settings-util'
import ResponseWatcher from './processed-response-watcher'
import NavWatcher from './autonav-watcher'

export default class AutoNavUrl {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._responseWatcher = new ResponseWatcher(this._settings);
        this._autoNavWatcher = new NavWatcher(this._settings);
    }

    static getDefaultSettings() {
        return settings;
    }

    getReducer() {
        return reducer;
    }

    initialize(store) {
        this._responseWatcher.initialize(store);
        this._autoNavWatcher.initialize(store);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/auto-nav-url/src/auto-nav-url.js